import { Fuel, Wrench, CircleDot, Package, FileText, Hammer } from 'lucide-react';
import { format, subMonths } from 'date-fns';

export const COLORS = ['#2563EB', '#DC2626', '#16A34A', '#F59E0B', '#8B5CF6', '#EC4899'];

export const CHART_COLORS = {
  fuel: '#2563EB',
  service: '#DC2626',
  tyres: '#16A34A',
  other: '#F59E0B',
  insurance: '#8B5CF6',
  maintenance: '#EC4899',
  labour: '#0D9488',
};

// Format Rand: R 1,234.56
export const fmtR = (v) => {
  if (v == null || isNaN(v)) return 'R 0.00';
  const n = Number(v);
  const parts = n.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `R ${parts.join('.')}`;
};

export const COST_TYPE_ICONS = {
  fuel: Fuel,
  service: Wrench,
  tyres: CircleDot,
  other: Package,
  maintenance: Wrench,
  insurance: FileText,
  labour: Hammer,
};

export const COST_TYPE_BG = {
  fuel: 'bg-blue-100 text-blue-600',
  service: 'bg-red-100 text-red-600',
  tyres: 'bg-green-100 text-green-600',
  other: 'bg-amber-100 text-amber-600',
  maintenance: 'bg-pink-100 text-pink-600',
  insurance: 'bg-purple-100 text-purple-600',
  labour: 'bg-teal-100 text-teal-600',
};

// Shared chart config constants
export const RPT_AXIS_TICK = { fill: '#64748B', fontSize: 12 };
export const RPT_AXIS_TICK_BOLD = { fill: '#1E293B', fontSize: 12, fontWeight: 500 };
export const RPT_TOOLTIP_STYLE = { backgroundColor: '#fff', border: '1px solid #E2E8F0', borderRadius: '6px' };
export const RPT_BAR_RADIUS_TOP = [4, 4, 0, 0];
export const RPT_BAR_RADIUS_NONE = [0, 0, 0, 0];
export const RPT_BAR_RADIUS_RIGHT = [0, 4, 4, 0];

// Build month options (last 24 months + current)
export const buildMonthOptions = () => {
  const months = [];
  const now = new Date();
  for (let i = 0; i < 24; i++) {
    const d = subMonths(now, i);
    months.push({
      value: format(d, 'yyyy-MM'),
      label: format(d, 'MMMM yyyy'),
    });
  }
  return months;
};
